import { SubmitHandler, useForm } from "react-hook-form";
import React from "react";
import { useAuth } from "../providers/auth";
import { useNotifications } from "../providers/notifications";
import { useNavigate } from "react-router-dom";

type Inputs = {
  full_name: string;
  phone: string;
  email: string;
};

export default () => {
  const {
    register,
    reset,
    handleSubmit,
    formState: { errors, isValid },
  } = useForm<Inputs>();
  const { session } = useAuth();
  const { notify } = useNotifications();
  const navigate = useNavigate();
  const onSubmit: SubmitHandler<Inputs> = (data) =>
    fetch("https://admin-api.prval.us/users", {
      method: "POST",
      body: JSON.stringify({ user: data }),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${session?.access_token}`,
      },
    })
      .then((res) => {
        if (!res.ok) {
          throw new Error("Failed to create user");
        }
        notify("User created successfully!", "success", 3000);
        navigate("/valets");
        reset({});
      })
      .catch((error) => {
        notify(
          "Error while creating the user. Please try again.",
          "error",
          3000
        );
      });

  return (
    <form
      onSubmit={handleSubmit(onSubmit)}
      className="flex flex-col md:flex-row gap-2"
    >
      <div className="form-control grow">
        <input
          type="text"
          className="input input-bordered grow"
          placeholder="Name"
          {...register("full_name", { required: true })}
        />
      </div>
      <div className="form-control grow">
        <input
          type="tel"
          className="input input-bordered"
          placeholder="Phone Number"
          {...register("phone", {
            required: true,
          })}
        />
      </div>
      <div className="form-control grow">
        <input
          type="email"
          className="input input-bordered"
          placeholder="Email (optional)"
          {...register("email")}
        />
      </div>
      <button
        disabled={!isValid}
        className="btn btn-primary mt-2 md:mt-0"
        type="submit"
      >
        Invite Valet
      </button>
    </form>
  );
};
